// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"ml_a pz_g"};